const ALLOWED_KEYS = {
  a: true,
  s: true,
  d: true,
  f: true,
  g: true,
  h: true,
  j: true,
  k: true,
  w: true,
  e: true,
  t: true,
  y: true,
  u: true
};

export default ALLOWED_KEYS;
